export default __webpack_public_path__ + "static/media/5ce36069ac26d4a9.20e29ad0ac948781d5b94120c1251f01.svg";